import { Icon, IconSprite } from '@ellucian/ds-icons/lib';
import Lookup from '@ev/react-lookup';
import DatePicker from '@ev/react-datepicker';
import {
    ActionMenu,
    ActionMenuItem,
    Dropdown,
    DropdownItem,
    FormControl,
    Grid,
    IconButton,
    TextField,
    Tooltip,
    Typography,
    CircularProgress
} from '@ellucian/react-design-system/core';
import { withStyles } from '@ellucian/react-design-system/core/styles';
import {
    borderWidthThick,
    colorBorderGlobalFocus,
    colorBrandNeutral100,
    colorBrandNeutral200,
    colorBrandNeutral500,
    fontSizeDefault,
    spacingSmall,
} from '@ellucian/react-design-system/core/styles/tokens';
import * as Tokens from '@ellucian/react-design-system/core/styles/tokens';
import classnames from 'classnames';
import React = require('react');
import { CardInternal } from './CardInternal';
import { IGroupButtonResources } from './GroupButton';
import GroupButtonArea from './GroupButtonArea';
import { Condition } from './models/Group';
import helper from './models/Helper';
import { AttributeType, IAttribute, IOperator, IRule, IQueryRuleComponentsProps } from './models/Rule';

const styles = (_theme) => ({
    // largest viewport
    [`@media only screen and (min-width: 1393px)`]: {
        operator: {
            width: ['191px', '!important']
        },
        value: {
            width: ['336px', '!important']
        },
        valueWithValueB: {
            width: ['179px', '!important']
        },
    },
    // next largest viewport
    [`@media only screen and (min-width: 1000px) and (max-width: 1392px)`]: {
        buttons: {
            paddingTop: '3px',
            width: ['700px', '!important']
        },
        operator: {
            width: ['336px', '!important']
        },
        readOnlyText: {
            paddingBottom: ['0px', '!important'],
            paddingTop: ['0px', '!important'],
        },
        readOnlyTextAttribute: {
            paddingBottom: ['0px', '!important'],
        },
        readOnlyTextOperator: {
            paddingBottom: ['0px', '!important'],
        },
        value: {
            width: ['336px', '!important']
        },
        valueWithValueB: {
            width: ['336px', '!important']
        },
    },
    // smallest viewport
    [`@media only screen and (max-width: 999px)`]: {
        buttons: {
            paddingTop: '10px',
            width: ['336px', '!important']
        },
        operator: {
            width: ['336px', '!important']
        },
        readOnlyText: {
            paddingBottom: ['0px', '!important'],
            paddingTop: ['0px', '!important'],
        },
        readOnlyTextAttribute: {
            paddingBottom: ['0px', '!important'],
        },
        readOnlyTextOperator: {
            paddingBottom: ['0px', '!important'],
            paddingTop: ['0px', '!important'],
        },
        value: {
            width: ['336px', '!important']
        },
        valueWithValueB: {
            width: ['336px', '!important']
        },
    },
    actionMenu: {
        marginLeft: '5px',
    },
    attributeBackIcon: {
        marginBottom: '-3px',
        marginRight: '5px',
    },
    attributeInputStartAdornment: {
        cursor: 'pointer',
    },
    attributeRelationshipIcon: {
        marginRight: '-25px',
        position: 'absolute',
        right: '0px',
        top: '21px',
    },
    button: {
        marginLeft: '10px',
    },
    buttons: {
        alignItems: 'center',
        display: 'flex',
        flexGrow: '1',
        justifyContent: 'flex-end',
        marginRight: '20px',
    },
    circularProgressValueA: {
        position: ['relative', '!important'],
        left: '50%',
        top: '15%',
    },
    headerText: {
        color: Tokens.colorTextSecondary,
        display: 'flex',
        padding: '1rem 0 1rem 1rem',
        textAlign: 'left',
    },
    headerTextItalic: {
        color: Tokens.colorTextSecondary,
        display: 'inline',
        fontStyle: 'italic',
        textAlign: 'left',
    },
    operator: {
        backgroundColor: colorBrandNeutral100,
    },

    readOnlyAttributePathLabel: {
        color: colorBrandNeutral500,
        fontSize: fontSizeDefault,
        lineHeight: 'normal',
        transform: 'translate(0, 1.5px) scale(0.75)',
        transformOrigin: 'top left',
        width: '420px',
    },
    readOnlyAttributePathLabelMargin: {
        marginLeft: spacingSmall,
    },
    readOnlyText: {
        overflow: 'hidden',
        padding: '1rem 1rem 1rem 1rem',
        textAlign: 'left',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    readOnlyTextAttribute: {
        marginTop: '-17px',
        overflow: 'hidden',
        padding: '1rem 1rem 1rem 1rem',
        textAlign: 'left',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    readOnlyTextOperator: {
        overflow: 'hidden',
        padding: '1rem 1rem 1rem 1rem',
        textAlign: 'left',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    remove: {
        '&:focus, &:hover': {
            color: '#065AA5'
        },
        'cursor': 'pointer',
        'marginLeft': 'auto',
    },
    ruleHeader: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginBottom: '5px',
        paddingBottom: '5px',
        paddingTop: '5px'
    },
    ruleHeaderContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
    rulePaper: {
        '&:hover': {
            backgroundColor: colorBrandNeutral200,
        },
        'border': `${borderWidthThick} solid transparent`,
        'display': 'flex',
        'flexDirection': 'row',
        'flexWrap': 'wrap',
        'marginBottom': '15px',
        'padding': '10px',
        'textAlign': 'left',
        'width': '100%',
    },
    rulePaperContainer: {
        flex: '1 1 auto',
    },
    rulePaperReadOnly: {
        cursor: 'pointer',
    },
    rulePaperSelected: {
        border: `${borderWidthThick} solid ${colorBorderGlobalFocus}`,
    },
    ruleRecord: {
        display: 'flex',
        flexDirection: 'row',
    },
    value: {
        backgroundColor: colorBrandNeutral100,
    },
    valueWithValueB: {
        backgroundColor: colorBrandNeutral100,
    },
    buttonRight: {
        textAlign: 'right',
        marginTop: '5px',
    }
});

const idPrefixHeader = 'queryBuilderHeader';
const idPrefixRule = 'queryBuilderRule';
const attributePathMaxWidth = 300;
const attributePathTooltipMaxWidth = 250;
const attributePathFont = '11px Open Sans';
const attributePathDelimiter = '>';
const attributePathEllipsis = '...';

export interface IQueryRuleResources {
    backAttributeLabel: string;
    dateFormat: string;
    defaultLookupValueLabel: string;
    deleteAction: string;
    deselectAction: string;
    duplicateRuleAction: string;
    editAction: string;
    enterValue: string;
    lookupValuePlaceholder: string;
    selectAction: string;
    selectAttribute: string;
    selectDate: string;
    selectOperator: string;
    selectValue: string;
    groupButton?: IGroupButtonResources;
    checkLabel: string;
    cancelLabel: string;
}

export interface IQueryRuleProps {
    onAlertError?: (message: string, showDefault?: boolean, key?: string) => void;
    classes: any;
    // tslint:disable-next-line: max-line-length
    fetchAttributeSuggestions: (term: string, requestId: number, relationshipAttribute: IAttribute) => Promise<any>;
    debounceInterval?: number;
    disableAddGroupFromSelectedRules?: boolean;
    fetchLookupValueSuggestions: (attribute: IAttribute, term: string, requestId: number) => Promise<{ id: string, title: string }>; // tslint:disable-line: max-line-length
    id?: string;
    isEditing?: boolean;
    isSelected?: boolean;
    lineId?: string;
    onAddGroupFromSelectedRules: (groupId: string) => void;
    onAddRule: (groupId: string) => void;
    onAddSelectedRules: (groupId: string) => void;
    onAttributeChange: (attribute: IAttribute) => void;
    onChangeGroupCondition: (groupId: string, condition: Condition) => void;
    onDelete: (rule: IRule) => void;
    onDuplicateRule: (rule: IRule) => void;
    onEditCancel: (rule: IRule) => void;
    onEditFinish: (rule: IRule) => void;
    onEditStart: (rule: IRule) => void;
    onRuleChanged: (rule: IRule) => void;
    onSelectRule: (rule: IRule) => void;
    onUnselectRule: (rule: IRule) => void;
    onSelectGroup: (groupId: string) => void;
    onUngroup: (groupId: string) => void;
    onUnselectGroup: (groupId: string) => void;
    rule?: IRule;
    ruleIndex?: string;
    selectedGroupIds: string[];
    strings: IQueryRuleResources;
    supportedGroupDepth?: number;
    lookupModifiers?: object;
    readOnly?: boolean;
    selectAttributeMode?: boolean;
    queryRuleComponentsProps?: IQueryRuleComponentsProps;
}

export class QueryRuleInternal extends React.Component<IQueryRuleProps, IRule> {
    public static defaultProps = {
        readOnly: false,
        strings: {
            backAttributeLabel: 'Back to Parent Model',
            dateFormat: 'MM/DD/YYYY',
            defaultLookupValueLabel: 'Title',
            deleteAction: 'Delete',
            deselectAction: 'Deselect',
            duplicateRuleAction: 'Copy Rule',
            editAction: 'Edit',
            enterValue: 'Enter Value',
            lookupValuePlaceholder: 'Select Value',
            selectAction: 'Select',
            selectAttribute: 'Select Attribute',
            selectDate: 'Select Date',
            selectOperator: 'Select Operator',
            selectValue: 'Select Value',
            checkLabel: 'Ok',
            cancelLabel: 'Cancel',
        },
    };

    private prevValidationError: string = null;
    private clearAttributeLookup: () => void = null;
    private openAttributeMenu: () => void = null;

    constructor(props: IQueryRuleProps) {
        super(props);

        const rule = props.rule;

        this.state = {
            attribute: rule.attribute || null,
            operator: rule.operator || '',
            relationshipAttributePath: rule.relationshipAttributePath || [],
            value: rule.value || '',
            valueB: rule.valueB || '',
        };
    }

    public render() {
        const {
            classes,
            debounceInterval,
            fetchLookupValueSuggestions,
            // id,
            disableAddGroupFromSelectedRules,
            lineId,
            onAddGroupFromSelectedRules,
            onAddRule,
            onAddSelectedRules,
            onAttributeChange,
            onChangeGroupCondition,
            onSelectRule,
            onUnselectRule,
            onSelectGroup,
            onUngroup,
            onUnselectGroup,
            rule,
            ruleIndex,
            selectedGroupIds = [],
            strings,
            supportedGroupDepth,
            lookupModifiers,
            readOnly,
            selectAttributeMode,
            onAlertError,
            queryRuleComponentsProps,
        } = this.props;

        let {
            isEditing,
            isSelected
        } = this.props;

        const {
            attribute,
            operator,
            relationshipAttributePath,
            value,
            valueB
        } = this.state;

        let operators: IOperator[];

        if (attribute) {
            operators = attribute.operators;
        }

        if (attribute && attribute.type === AttributeType.Int) {
            attribute.validate = this.validateNumberField;
        }

        const cleanValue = helper.getCleansedValue(attribute, value);
        const cleanValueB = helper.getCleansedValue(attribute, valueB);
        const operatorLabel = helper.getOperatorLabel(attribute, operator);
        const valueLabel = helper.getValueLabel(attribute, value, strings.dateFormat);
        const { actions, newIsEditing } = this.generateActions();

        isEditing = newIsEditing;

        isSelected = selectedGroupIds.length ? // if groups are selected, it trumps individual selection
            !!selectedGroupIds.find((gid) => rule.groupIds.indexOf(gid) >= 0) :
            isSelected;

        const attributeLookupLabel = this.getAttributeLookupLabel(attribute, relationshipAttributePath);
        const lookupValueLabel = attribute ? attribute.lookupValueLabel || strings.defaultLookupValueLabel : '';
        const lookupValueMinLength = attribute ? attribute.lookupValueMinLength || 0 : 0;

        let validationError = '';
        const hasValue = (Array.isArray(value) ? value.length > 0 : !!value)
        if (isEditing && attribute && hasValue && attribute.validate) {
            validationError = attribute.validate(this.state);
        }
        if (this.prevValidationError !== validationError) {
            setTimeout(() => window.dispatchEvent(new Event('customResize')), 0);
        }
        this.prevValidationError = validationError;

        const hideValueInput = helper.hideValueInput(this.state);

        // give the value classes smaller width to share space if there is a valueB;
        // otherwise we hide the valueB elements and make valueA large.
        const requiresValueB = helper.requiresValueB(this.state);
        const valueClass = requiresValueB ? classes.valueWithValueB : classes.value;

        return (
            <div className={classes.ruleRecord}>
                {!selectAttributeMode &&
                    <GroupButtonArea
                        ruleIndex={ruleIndex}
                        disableAddGroupFromSelectedRules={disableAddGroupFromSelectedRules}
                        onAddGroupFromSelectedRules={onAddGroupFromSelectedRules}
                        onAddRule={onAddRule}
                        onAddSelectedRules={onAddSelectedRules}
                        onChangeGroupCondition={onChangeGroupCondition}
                        onSelectGroup={onSelectGroup}
                        onUngroup={onUngroup}
                        onUnselectGroup={onUnselectGroup}
                        groupButtons={rule.$$groupButtons}
                        selectedGroupIds={selectedGroupIds}
                        strings={strings.groupButton}
                        supportedGroupDepth={supportedGroupDepth}
                        readOnly={readOnly}
                    />
                }

                <IconSprite />
                <CardInternal
                    lineId={lineId}
                    idPrefixRule={idPrefixRule}
                    ruleIndex={ruleIndex}
                    classes={classes}
                    isSelected={isSelected}
                    isEditing={isEditing}
                    readOnly={readOnly}
                    onUnselectRule={onUnselectRule}
                    rule={rule}
                    onSelectRule={onSelectRule}
                    selectAttributeMode={selectAttributeMode ? selectAttributeMode : false}
                >
                    {isEditing &&
                        <Grid container spacing={1}>
                            <Grid item lg={10}>
                                <Grid container justify="flex-start" spacing={1}>
                                    <Grid item>
                                        <Tooltip
                                            title={this.getAttributeLookupTooltip(attribute, relationshipAttributePath)}
                                            placement="top-start"
                                            open={queryRuleComponentsProps?.selectAttributeComponent?.persistTooltip ? !!attribute : undefined}
                                            disableFocusListener={true}
                                        >
                                            <div id={`${idPrefixRule}_attributePathTooltip_${ruleIndex}`}>
                                                <Lookup
                                                    id={`${idPrefixRule}_attributeEdit_${ruleIndex}`}
                                                    onAlertError={onAlertError}
                                                    fetchSuggestions={(term, requestId) =>
                                                        this.fetchAttributeSuggestionsInner(
                                                            term, requestId, relationshipAttributePath)
                                                    }
                                                    label={attributeLookupLabel}
                                                    placeholder={strings.selectAttribute}
                                                    // tslint:disable-next-line: max-line-length
                                                    inputStartAdornmentContent={
                                                        this.getAttributeInputStartAdornment(
                                                            `${idPrefixRule}_attributeEdit_${ruleIndex}_backButton`,
                                                            relationshipAttributePath
                                                        )
                                                    }
                                                    minLength="0"
                                                    searchIconName="chevron-down"
                                                    onChange={(newAttribute: IAttribute) => {
                                                        const myRelationshipAttributePath = [...relationshipAttributePath];

                                                        // if we just selected a relationship, then we must populate the path
                                                        // but clear the attribute lookup.
                                                        if (newAttribute && newAttribute.type === AttributeType.Relationship) {
                                                            const relationshipAttribute = {
                                                                ...newAttribute,
                                                                // tslint:disable-next-line: max-line-length
                                                                path: [...newAttribute.path || [], { label: newAttribute.label, value: newAttribute.value }]
                                                            };
                                                            myRelationshipAttributePath.push(relationshipAttribute);

                                                            newAttribute = null;
                                                            this.clearAttributeLookup();

                                                            // This code pops open the menu after a folder is
                                                            // selected, but we need to fix another bug before we
                                                            // are ready for this logic to be enabled.
                                                            // See EV-1285.
                                                            this.openAttributeMenu();
                                                        }

                                                        this.onChange({
                                                            attribute: newAttribute,
                                                            operator: null,
                                                            relationshipAttributePath: myRelationshipAttributePath,
                                                            value: null,
                                                        });

                                                        if (onAttributeChange) {
                                                            onAttributeChange(newAttribute);
                                                        }
                                                    }}
                                                    onClear={() => {
                                                        this.onChange({
                                                            attribute: null,
                                                            operator: null,
                                                            relationshipAttributePath: [],
                                                            value: null,
                                                        });

                                                        if (onAttributeChange) {
                                                            onAttributeChange(null);
                                                        }
                                                    }}
                                                    selectedValue={attribute}
                                                    debounceInterval={debounceInterval}
                                                    modifiers={lookupModifiers}
                                                    setClear={(clear) => this.clearAttributeLookup = clear}
                                                    setOpenMenu={(openMenu) => this.openAttributeMenu = openMenu}
                                                    error={queryRuleComponentsProps?.selectAttributeComponent?.error ?? false}
                                                    helperText={queryRuleComponentsProps?.selectAttributeComponent?.helperText ?? ''}
                                                >
                                                    {(it: IAttribute) => {
                                                        return (
                                                            <Tooltip
                                                                title={
                                                                    this.getAttributeLookupTooltip(
                                                                        it, relationshipAttributePath)
                                                                }
                                                                placement="top-start"
                                                                enterDelay={250}
                                                            >
                                                                <div>
                                                                    <Typography
                                                                        className={classes.readOnlyAttributePathLabel}
                                                                        variant="body3"
                                                                        style={{
                                                                            color: colorBrandNeutral500,
                                                                            fontSize: fontSizeDefault,
                                                                            lineHeight: 'normal',
                                                                            transform: 'translate(0, 1.5px) scale(0.75)',
                                                                            transformOrigin: 'top left',
                                                                            width: '420px',
                                                                        }}
                                                                    >
                                                                        {
                                                                            // tslint:disable-next-line: max-line-length
                                                                            this.getAttributeLookupLabel(it)
                                                                        }
                                                                    </Typography>
                                                                    <Typography variant="body1">
                                                                        {it.label}
                                                                    </Typography>
                                                                    {it.type === AttributeType.Relationship &&
                                                                        <Icon
                                                                            className={classes.attributeRelationshipIcon}
                                                                            name="chevron-right"
                                                                        />
                                                                    }
                                                                </div>
                                                            </Tooltip>
                                                        );
                                                    }}
                                                </Lookup>
                                            </div>
                                       </Tooltip>
                                    </Grid>
                                    <Grid item>
                                        {!selectAttributeMode && attribute && operators &&
                                            <FormControl className={classes.operator}>
                                                <Dropdown
                                                    id={`${idPrefixRule}_operatorEdit_${ruleIndex}`}
                                                    onChange={(event) => {
                                                        const myState = {
                                                            operator: event.target.value
                                                        } as IRule;

                                                        // clear value B if no longer relevant
                                                        myState.valueB =
                                                            helper.requiresValueB({ ...this.state, ...myState }) ?
                                                                valueB : null;

                                                        this.onChange(myState);
                                                    }}
                                                    label={strings.selectOperator}
                                                    value={operator || ''}
                                                >
                                                    {operators.map((it) => (
                                                        <DropdownItem key={it.value} label={it.label} value={it.value} />
                                                    ))}
                                                </Dropdown>
                                            </FormControl>
                                        }
                                    </Grid>
                                    <Grid item>
                                        {!hideValueInput && !selectAttributeMode && attribute && operators &&
                                            <>
                                                {attribute.type === AttributeType.Date &&
                                                    <DatePicker
                                                        id={`${idPrefixRule}_valueDateEdit_${ruleIndex}`}
                                                        className={valueClass}
                                                        displayFormat={strings.dateFormat}
                                                        isOutsideRange={() => false}
                                                        nativeDate={cleanValue as Date}
                                                        autoPosition={true}
                                                        onNativeDateChange={(event) => {
                                                            this.onChange({
                                                                value: event.target.value,
                                                            }, false);
                                                        }}
                                                        placeholder={strings.selectDate}
                                                    />
                                                }

                                                {(attribute.type === AttributeType.Enum || attribute.type === AttributeType.RadioChoiceEnum) &&
                                                    <FormControl className={valueClass}>
                                                        <Dropdown
                                                            id={`${idPrefixRule}_value${attribute.type}Edit_${ruleIndex}`}
                                                            onChange={(event) => {
                                                                this.onChange({
                                                                    value: event.target.value,
                                                                }, false);
                                                            }}
                                                            label={strings.selectValue}
                                                            value={cleanValue || ''}
                                                        >
                                                            {attribute.enum.map((it) => (
                                                                <DropdownItem
                                                                    key={it.value}
                                                                    label={it.label}
                                                                    value={it.value}
                                                                />
                                                            ))}
                                                        </Dropdown>
                                                    </FormControl>
                                                }

                                                {attribute.type === AttributeType.MultiSelectEnum  &&
                                                    <React.Fragment>
                                                        {!attribute.isLoading &&
                                                            <FormControl className={valueClass}>
                                                                <Dropdown
                                                                    id={`${idPrefixRule}_value${attribute.type}Edit_${ruleIndex}`}
                                                                    onChange={(event) => {
                                                                        this.onChange({
                                                                            value: event.target.value,
                                                                        }, false);
                                                                    }}
                                                                    label={strings.selectValue}
                                                                    value={cleanValue || []}
                                                                    multiple={true}
                                                                    showSelectAll={true}
                                                                >
                                                                    {attribute.enum.map((it) => (
                                                                        <DropdownItem
                                                                            key={it.value}
                                                                            label={it.label}
                                                                            value={it.value}
                                                                        />
                                                                    ))}
                                                                </Dropdown>
                                                            </FormControl>
                                                        }
                                                        {attribute.isLoading &&
                                                            <div className={classes.circularProgressValueA}>
                                                                <CircularProgress />
                                                            </div>
                                                        }
                                                    </React.Fragment>
                                                }

                                                {(attribute.type === AttributeType.String
                                                    || attribute.type === AttributeType.Int) &&
                                                    <TextField
                                                        id={`${idPrefixRule}_valueTextEdit_${ruleIndex}`}
                                                        className={valueClass}
                                                        label={strings.enterValue}
                                                        error={!!validationError}
                                                        helperText={validationError}
                                                        type={attribute.type === AttributeType.Int ? 'number' : 'text'}
                                                        onChange={(event) => {
                                                            this.onChange({
                                                                value: attribute.type === AttributeType.Int ? event : event.target.value,
                                                            }, false);
                                                        }}
                                                        value={cleanValue}
                                                    />
                                                }

                                                {(attribute.type === AttributeType.Lookup) &&
                                                    <Lookup
                                                        id={`${idPrefixRule}_valueLookupEdit_${ruleIndex}`}
                                                        className={valueClass}
                                                        onAlertError={onAlertError}
                                                        fetchSuggestions={(term, requestId) =>
                                                            fetchLookupValueSuggestions(attribute, term, requestId)
                                                        }
                                                        label={lookupValueLabel}
                                                        minLength={lookupValueMinLength}
                                                        searchIconName="chevron-down"
                                                        onChange={(newValue) => {
                                                            this.onChange({
                                                                value: newValue
                                                            }, false);
                                                        }}
                                                        selectedValue={cleanValue}
                                                        placeholder={strings.lookupValuePlaceholder}
                                                        suggestionToString={(it) => it ? it.title : ''}
                                                        suggestionToValue={(it) => it && it.id}
                                                        modifiers={lookupModifiers}
                                                    />
                                                }
                                            </>
                                        }
                                        {!hideValueInput && attribute && operators && requiresValueB &&
                                            <React.Fragment>
                                                {attribute.type === AttributeType.Date &&
                                                    <DatePicker
                                                        id={`${idPrefixRule}_valueBDateEdit_${ruleIndex}`}
                                                        className={valueClass}
                                                        displayFormat={strings.dateFormat}
                                                        isOutsideRange={() => false}
                                                        nativeDate={cleanValueB as Date}
                                                        onNativeDateChange={(event) => {
                                                            this.onChange({
                                                                valueB: event.target.value,
                                                            }, false);
                                                        }}
                                                        placeholder={strings.selectDate}
                                                    />
                                                }

                                                {(attribute.type === AttributeType.Enum || attribute.type === AttributeType.RadioChoiceEnum) &&
                                                    <FormControl className={valueClass}>
                                                        <Dropdown
                                                            id={`${idPrefixRule}_value${attribute.type}Edit_${ruleIndex}`}
                                                            onChange={(event) => {
                                                                this.onChange({
                                                                    valueB: event.target.value,
                                                                }, false);
                                                            }}
                                                            label={strings.selectValue}
                                                            value={cleanValueB || ''}
                                                        >
                                                            {attribute.enum.map((it) => (
                                                                // tslint:disable-next-line: max-line-length
                                                                <DropdownItem key={it.value} label={it.label} value={it.value} />
                                                            ))}
                                                        </Dropdown>
                                                    </FormControl>
                                                }

                                                {attribute.type === AttributeType.MultiSelectEnum &&
                                                    <FormControl className={valueClass}>
                                                        <Dropdown
                                                            id={`${idPrefixRule}_value${attribute.type}Edit_${ruleIndex}`}
                                                            onChange={(event) => {
                                                                this.onChange({
                                                                    value: event.target.value,
                                                                }, false);
                                                            }}
                                                            label={strings.selectValue}
                                                            value={cleanValue || []}
                                                            multiple={true}
                                                        >
                                                            {attribute.enum.map((it) => (
                                                                <DropdownItem
                                                                    key={it.value}
                                                                    label={it.label}
                                                                    value={it.value}
                                                                />
                                                            ))}
                                                        </Dropdown>
                                                    </FormControl>
                                                }

                                                {(attribute.type === AttributeType.String
                                                    || attribute.type === AttributeType.Int) &&
                                                    <TextField
                                                        id={`${idPrefixRule}_valueBTextEdit_${ruleIndex}`}
                                                        className={valueClass}
                                                        label={strings.enterValue}
                                                        type={attribute.type === AttributeType.Int ? 'number' : 'text'}
                                                        onChange={(event) => {
                                                            this.onChange({
                                                                valueB: attribute.type === AttributeType.Int ? event : event.target.value,
                                                            }, false);
                                                        }}
                                                        value={cleanValueB}
                                                    />
                                                }

                                                {(attribute.type === AttributeType.Lookup) &&
                                                    <Lookup
                                                        id={`${idPrefixRule}_valueBLookupEdit_${ruleIndex}`}
                                                        fetchSuggestions={(term, requestId) =>
                                                            fetchLookupValueSuggestions(attribute, term, requestId)
                                                        }
                                                        onAlertError={onAlertError}
                                                        label={lookupValueLabel}
                                                        searchIconName="chevron-down"
                                                        minLength={lookupValueMinLength}
                                                        onChange={(newValue) => {
                                                            this.onChange({
                                                                valueB: newValue
                                                            }, false);
                                                        }}
                                                        selectedValue={cleanValueB}
                                                        placeholder={strings.lookupValuePlaceholder}
                                                        suggestionToString={(it) => it ? it.title : ''}
                                                        suggestionToValue={(it) => it && it.id}
                                                        modifiers={lookupModifiers}
                                                    />
                                                }
                                            </React.Fragment>
                                        }
                                    </Grid>

                                </Grid>
                            </Grid>
                            {!selectAttributeMode &&
                                <Grid item md={12} lg={2} className={classes.buttonRight}>
                                    <IconButton
                                        id={`${idPrefixRule}_cancelButton_${ruleIndex}`}
                                        color="secondary"
                                        className={classes.button}
                                        large="true"
                                        onClick={() => {
                                            if (isSelected && onUnselectRule) {
                                                onUnselectRule(rule);
                                            }
                                            this.onEditCancel();
                                        }}
                                        aria-label={strings.cancelLabel}
                                    >
                                        <Icon name="close" />
                                    </IconButton>
                                    <IconButton
                                        id={`${idPrefixRule}_finishButton_${ruleIndex}`}
                                        color="primary"
                                        className={classes.button}
                                        large="true"
                                        disabled={!helper.isValid(this.state) || !!validationError}
                                        onClick={() => {
                                            if (isSelected && onUnselectRule) {
                                                onUnselectRule(rule);
                                            }
                                            this.onEditFinish();
                                        }}
                                        aria-label={strings.checkLabel}
                                    >
                                        <Icon name="check" />
                                    </IconButton>
                                </Grid>
                            }
                        </Grid>
                    }
                    {!isEditing &&
                        <Grid container spacing={1}>
                            <Grid item md={12} lg={4}>
                                <Tooltip
                                    id={`${idPrefixRule}_attributePathReadOnlyTooltip_${ruleIndex}`}
                                    title={this.getAttributeLookupTooltip(attribute, relationshipAttributePath)}
                                    placement="top-start"
                                >
                                    <div id={`${idPrefixRule}_attributePathReadOnly_${ruleIndex}`}>
                                        <Typography
                                            className={classnames(
                                                classes.readOnlyAttributePathLabel,
                                                classes.readOnlyAttributePathLabelMargin,
                                            )}
                                            variant="body3"
                                        >
                                            {attributeLookupLabel}
                                        </Typography>
                                        <Typography
                                            className={classnames({
                                                [classes.readOnlyTextAttribute]: attributeLookupLabel,
                                                [classes.readOnlyText]: !attributeLookupLabel,
                                            })}
                                            id={`${idPrefixRule}_attributeReadOnly_${ruleIndex}`}
                                            style={{}}
                                        >
                                            {attribute && attribute.label}
                                        </Typography>
                                    </div>
                                </Tooltip>
                            </Grid>
                            <Grid item md={12} lg={2}>
                                {!selectAttributeMode && attribute && operators &&
                                    <Tooltip title={operatorLabel} placement="top-start">
                                        <Typography
                                            id={`${idPrefixRule}_operatorReadOnly_${ruleIndex}`}
                                            className={classnames({
                                                [classes.readOnlyTextOperator]: attributeLookupLabel,
                                                [classes.readOnlyText]: !attributeLookupLabel,
                                            })}
                                        >
                                            {operatorLabel}
                                        </Typography>
                                    </Tooltip>
                                }

                            </Grid>
                            <Grid item md={12} lg={4}>
                                {!selectAttributeMode &&
                                    <Tooltip title={valueLabel} placement="top-start">
                                        <Typography
                                            className={classes.readOnlyText}
                                            id={`${idPrefixRule}_valueReadOnly_${ruleIndex}`}
                                        >
                                            {valueLabel}
                                        </Typography>
                                    </Tooltip>
                                }
                            </Grid>
                            <Grid item md={12} lg={2} className={classes.buttonRight}>
                                {!selectAttributeMode && !readOnly && attribute && operators &&
                                    <div className={classes.actionMenu}>
                                        <ActionMenu
                                            menuId={`${idPrefixRule}_actionMenu_${ruleIndex}`}
                                        >
                                            {actions && !!actions.length && actions.map((action) => (
                                                <ActionMenuItem onClick={action.callback} key={action.label}>
                                                    {action.label}
                                                </ActionMenuItem>
                                            ))}
                                        </ActionMenu>
                                    </div>
                                }
                            </Grid>
                        </Grid>
                    }
                </CardInternal>
            </div>
        );
    }

    public getAttributeInputStartAdornment(id: string, relationshipAttributePath: IAttribute[]): any {
        if (!relationshipAttributePath || !relationshipAttributePath.length) {
            return null;
        }

        const {
            classes: myClasses,
            onAttributeChange,
            strings,
        } = this.props;

        return (
            <Tooltip
                title={strings.backAttributeLabel}
                placement="top-start"
            >
                <Icon
                    id={id}
                    name="chevron-left"
                    className={myClasses.attributeInputStartAdornment}
                    onClick={() => {
                        // if we just hit the back button, we have to popup the
                        // relationshipAttribute
                        relationshipAttributePath = [...relationshipAttributePath];
                        relationshipAttributePath.pop();
                        this.clearAttributeLookup();

                        this.onChange({
                            attribute: null,
                            operator: null,
                            relationshipAttributePath,
                            value: null,
                        });

                        if (onAttributeChange) {
                            onAttributeChange(null);
                        }
                    }}
                />
            </Tooltip>
        );
    }

    public fetchAttributeSuggestionsInner = (
        term: string,
        requestId: number,
        relationshipAttributePath: IAttribute[]):
        Promise<any> => {
        const {
            fetchAttributeSuggestions,
            // strings
        } = this.props;

        const rap = relationshipAttributePath;
        const ra = rap.length > 0 ? rap[rap.length - 1] : null;

        return fetchAttributeSuggestions(term, requestId, ra)
            .then((response) => {
                // sort the relationships to the top
                response.suggestions.sort((a: IAttribute, b: IAttribute) => {
                    const rel = AttributeType.Relationship;
                    if (a.type !== rel && b.type !== rel) { return 0; }
                    if (a.type === rel) { return 1; }
                    if (b.type === rel) { return -1; }
                    return 0;
                });

                return response;
            });
    }

    public onChange = (rule: IRule, fireRuleChange: boolean = true) => {
        this.setState({ ...this.state, ...rule });
        if (this.props.onRuleChanged && fireRuleChange) {
            this.props.onRuleChanged(rule);
        }
    }

    public validateNumberField = (rule: IRule) => {
        if (isNaN(rule.value as number)) {
            return 'Please enter a number';
        }
        return null;
    };

    public onEditCancel = () => {
        this.onChange(this.props.rule);

        if (!this.props.onEditCancel) {
            return;
        }

        this.props.onEditCancel(this.props.rule);
    }

    public onEditFinish = () => {
        if (!this.props.onEditFinish) {
            return;
        }

        this.props.onEditFinish({ ...this.props.rule, ...this.state });
    }

    public generateActions = (): { actions: { callback: () => void; label: string }[], newIsEditing: boolean } => {
        const {
            isSelected,
            onDelete,
            onDuplicateRule,
            onEditStart,
            onSelectRule,
            onUnselectRule,
            rule,
            strings,
        } = this.props;

        let {
            isEditing,
        } = this.props;

        const actions = [];
        actions.push({
            callback: () => {
                isEditing = true;
                if (onSelectRule) {
                    onSelectRule(rule);
                }
                onEditStart(rule);
            },
            label: strings.editAction,
        });

        if (!isSelected) {
            actions.push({
                callback: () => {
                    if (!isSelected && onSelectRule) {
                        onSelectRule(rule);
                    }
                },
                label: strings.selectAction
            });
        } else {
            actions.push({
                callback: () => {
                    if (isSelected && onUnselectRule) {
                        onUnselectRule(rule);
                    }
                },
                label: strings.deselectAction
            });
        }

        actions.push({
            callback: () => onDuplicateRule(rule),
            label: strings.duplicateRuleAction
        });

        actions.push({
            callback: () => onDelete(rule),
            label: strings.deleteAction
        });

        return { actions, newIsEditing: isEditing };
    }

    public getTextWidth(text, font) {
        // tslint:disable-next-line: max-line-length
        const canvas = (this.getTextWidth as any).canvas || ((this.getTextWidth as any).canvas = document.createElement('canvas'));
        const context = canvas.getContext('2d');
        if (context) {
            context.font = font;
            const metrics = context.measureText(text);
            return metrics.width;
        }
        return 0;
    }

    public refineAttributeForLabel(attribute: IAttribute, relationshipAttributePath: IAttribute[]): IAttribute {
        if (attribute) {
            return attribute;
        }

        const rap = relationshipAttributePath;
        const ra = rap && rap.length > 0 ? rap[rap.length - 1] : null;
        if (!ra) {
            return attribute;
        }

        return { ...ra };
    }

    /**
     * Build the path label to appear in small text above the label.  Preference is for the first path
     * item, then the last, then the second, then the second to last, then the third, then the third
     * to last.  It uses an ellipsis in the middle of the text exceeds the max allowable characters.
     */
    public getAttributeLookupLabel = (
        attribute: IAttribute,
        relationshipAttributePath: IAttribute[] = null
    ): string => {
        attribute = this.refineAttributeForLabel(attribute, relationshipAttributePath);

        if (!attribute) {
            return this.props.strings.selectAttribute;
        }

        if (!attribute.path || !attribute.path.length) {
            return '';
        }

        let path = '';
        let doFront = true;
        let frontIndex = 0;
        let backIndex = attribute.path.length - 1;
        const frontPath: string[] = [];
        const backPath: string[] = [];
        const delimiter = attributePathDelimiter;
        const ellipsis = attributePathEllipsis;

        do {
            const pathItemLabel = attribute.path[doFront ? frontIndex : backIndex].label;

            path = [...frontPath, pathItemLabel, ...backPath]
                .filter((p) => p && p.length > 0)
                .join(delimiter);

            const width = this.getTextWidth(path + delimiter, attributePathFont);

            // if the latest one just exceeded the max width then return the last one that
            // didn't with an ellipsis in between
            if (width > attributePathMaxWidth) {
                const filteredFrontPath = frontPath.filter((p) => p && p.length > 0);
                const filteredBackPath = backPath.filter((p) => p && p.length > 0);
                path = `${filteredFrontPath.join(delimiter)}${ellipsis}${filteredBackPath.join(delimiter)}`;
                break;
            }

            if (doFront) {
                frontPath.push(pathItemLabel);
                frontIndex++;
            } else {
                backPath.unshift(pathItemLabel);
                backIndex--;
            }

            if (backIndex < frontIndex) {
                break;
            }

            doFront = !doFront;
        } while (true);

        return path;
    }

    public getAttributeLookupTooltip = (
        attribute: IAttribute,
        relationshipAttributePath: IAttribute[] = null
    ): string => {
        attribute = this.refineAttributeForLabel(attribute, relationshipAttributePath);

        if (!attribute) {
            return '';
        }

        if (!attribute.path || !attribute.path.length) {
            return attribute.label;
        }

        const path = [...attribute.path];
        // don't show label if we just have a relationship attribute
        if (attribute.type !== AttributeType.Relationship) {
            path.push({ label: attribute.label });
        }

        const tooltipLines: string[] = [];
        let tooltipLine = '';

        path.forEach((p) => {
            const delimiter = p.label && p.label.length ? attributePathDelimiter : '';
            let nextTooltipLine = tooltipLine + `${p.label}${delimiter}`;

            // if the tooltip is greater than max width, put onto next line
            const width = this.getTextWidth(nextTooltipLine, attributePathFont);
            if (width > attributePathTooltipMaxWidth) {
                tooltipLines.push(tooltipLine);
                nextTooltipLine = `${p.label}${delimiter}`;
            }

            tooltipLine = nextTooltipLine;
        });

        tooltipLines.push(tooltipLine.substring(0, tooltipLine.length - 1)); // remove trailing >

        return tooltipLines.join(' '); // empty space forces tooltip next line
    }
}

const QueryRule = [
    withStyles(styles),
].reduce((memo, hoc: (it: any) => any) => hoc(memo), QueryRuleInternal);

export default QueryRule;

/**
 * QueryRuleHeader also lives in this file so that JSS can be easily shared
 */

export interface IQueryRuleHeaderResources {
    attribute: string;
    operator: string;
    value: string;
}

interface IQueryRuleHeader {
    classes: any;
    strings: IQueryRuleHeaderResources;
    selectAttributeMode: boolean;
}

class QueryRuleHeaderInternal extends React.Component<IQueryRuleHeader, any> {
    public static defaultProps = {
        strings: {
            attribute: 'Attribute',
            operator: 'Operator',
            value: 'Value',
        },
    };

    constructor(props: IQueryRuleHeader) {
        super(props);
    }

    public render() {
        const {
            classes,
            strings,
            selectAttributeMode
        } = this.props;

        return (
            <React.Fragment>
                {!selectAttributeMode &&
                    <div className={classes.ruleHeaderContainer}>
                        <GroupButtonArea groupButtons={[]} />
                        <Grid container spacing={1}>
                            <Grid item md={12} lg={4}>
                                <Typography className={classes.headerText} id={`${idPrefixHeader}_attribute`}>
                                    {strings.attribute}
                                </Typography>
                            </Grid>
                            <Grid item md={12} lg={2}>
                                <Typography className={classes.headerText} id={`${idPrefixHeader}_operator`}>
                                    {strings.operator}
                                </Typography>
                            </Grid>
                            <Grid item md={12} lg={4}>
                                <Typography className={classes.headerText} id={`${idPrefixHeader}_value`}>
                                    {strings.value}
                                </Typography>
                            </Grid>
                        </Grid>
                    </div>
                }
            </React.Fragment>

        );
    }
}

export const QueryRuleHeader = [
    withStyles(styles),
].reduce((memo, hoc: (it: any) => any) => hoc(memo), QueryRuleHeaderInternal);